import {
  addBreadcrumb as consoleAddBreadcrumb,
  type LogOptions,
} from "./console-logging"
import { toLogRecord } from "./log-data"
import { scrubValue } from "./sentry-privacy"
import { getSentry, isSentryEnabled } from "./sentry-state"

export function addMonitorBreadcrumb(options: LogOptions) {
  consoleAddBreadcrumb(options)

  if (!isSentryEnabled()) return

  getSentry()?.addBreadcrumb({
    category: options.category ?? "log",
    message: options.message,
    level:
      options.level === "fatal"
        ? "error"
        : options.level === "warning"
          ? "warning"
          : (options.level ?? "info"),
    data: toLogRecord(options.data),
  })
}
